import { ClipboardModule } from '@angular/cdk/clipboard';
import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {
  DateAdapter,
  MatNativeDateModule,
  MatRippleModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  RippleGlobalOptions
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import {
  MatSelectModule,
  MAT_SELECT_SCROLL_STRATEGY
} from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { MatCarouselModule } from 'ng-mat-carousel';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MarkdownModule } from 'ngx-markdown';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMonthPickerModule } from 'ngx-month-picker-range';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PipesModule } from '../pipes/pipes.module';
import { ActiveOrderListComponent } from './active-order-list/active-order-list.component';
import { AddDefaultAddressComponent } from './add-default-address/add-default-address.component';
import { AdvisorPromotionsComponent } from './advisor-promotions/advisor-promotions.component';
import { AdvisorsDoctorComponent } from './advisors-doctor/advisors-doctor.component';
import { AutocompleteCodeMissingComponent } from './autocomplete-code-missing/autocomplete-code-missing.component';
import { AutocompleteMissingAutoComponent } from './autocomplete-missing-auto/autocomplete-missing-auto.component';
import { AutocompleteMissingContainerComponent } from './autocomplete-missing-container/autocomplete-missing-container.component';
import { BackOrderCardMobileComponent } from './back-order-card-mobile/back-order-card-mobile.component';
import { BottomSheetDinamicComponent } from './bottom-sheet-dinamic/bottom-sheet-dinamic.component';
import { BottomSheetMissingProductsComponent } from './bottom-sheet-missing-products/bottom-sheet-missing-products.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CardOrderComponent } from './card-order/card-order.component';
import { CarouselComponent } from './carousel/carousel.component';
import { CatalogChipsComponent } from './catalog-chips/catalog-chips.component';
import { CatalogComboboxComponent } from './catalog-combobox/catalog-combobox.component';
import { CatalogDownloadComponent } from './catalog-download/catalog-download.component';
import { CatalogFiltersComponent } from './catalog-filters/catalog-filters.component';
import { CatalogHeaderComponent } from './catalog-header/catalog-header.component';
import { CatalogInputTextComponent } from './catalog-input-text/catalog-input-text.component';
import { CatalogItemsComponent } from './catalog-items/catalog-items.components';
import { CatalogSpecialtyItemComponent } from './catalog-specialty-item/catalog-specialty-item.component';
import { CatalogsComponent } from './catalogs/catalogs.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChangeTaxDirectionComponent } from './change-tax-direction/change-tax-direction.component';
import { CircleLoadingComponent } from './circle-loading/circle-loading.component';
import { ClientHeaderComponent } from './client-header/client-header.component';
import { ClientItemComponent } from './client-item/client-item.component';
import { CodePayDescriptionComponent } from './code-pay-description/code-pay-description.component';
import { ConfirmShippingCostComponent } from './confirm-shipping-cost/confirm-shipping-cost.component';
import { ContainerBioEqualComponent } from './container-bio-equal/container-bio-equal.component';
import { ContainerBioeliteComponent } from './container-bioelite/container-bioelite.component';
import { ContainerDermazoneComponent } from './container-dermazone/container-dermazone.component';
import { ContainerReveComponent } from './container-reve/container-reve.component';
import { ContentEmptyComponent } from './content-empty/content-empty.component';
import { CounterPiecesComponent } from './counter-pieces/counter-pieces.component';
import { CustomPaginatorComponent } from './custom-paginator/custom-paginator.component';
import { DeleteProductComponent } from './delete-product/delete-product.component';
import { DeliveredOrdersListComponent } from './delivered-orders-list/delivered-orders-list.component';
import { DeliveryAddressListComponent } from './delivery-address-list/delivery-address-list.component';
import { DeliveryAddressesComponent } from './delivery-addresses/delivery-addresses.component';
import { DeliveryDirectionsComponent } from './delivery-directions/delivery-directions.component';
import { DetailOrdersListComponent } from './detail-orders-list/detail-orders-list.component';
import { DirectionItemComponent } from './direction-item/direction-item.component';
import { DiscountMessageComponent } from './discount-message/discount-message.component';
import { DoctorInformationComponent } from './doctor-information/doctor-information.component';
import { DownloadInvoiceComponent } from './download-invoice/download-invoice.component';
import { EditAndRepurchaseComponent } from './edit-and-repurchase/edit-and-repurchase.component';
import { FaqTopicComponent } from './faq-topic/faq-topic.component';
import { FaqsAccordionComponent } from './faqs-accordion/faqs-accordion.component';
import { FavoriteComponent } from './favorite/favorite.component';
import { FavoritesProductListComponent } from './favorites-product-list/favorites-product-list.component';
import { FileSelectedComponent } from './file-selected/file-selected.component';
import { FooterComponent } from './footer/footer.component';
import { GenerateOrderItemsComponent } from './generate-order-items/generate-order-items.component';
import { GoBackAsesorComponent } from './go-back-asesor/go-back-asesor.component';
import { GoalClientsComponent } from './goal-clients/goal-clients.component';
import { HeaderPageComponent } from './header-page/header-page.component';
import { HistoryOrdersListComponent } from './history-orders-list/history-orders-list.component';
import { HoffmanMessageComponent } from './hoffman-message/hoffman-message.component';
import { HomeOptionImgComponent } from './home-option-img/home-option-img.component';
import { IconPencilComponent } from './icon-pencil/icon-pencil.component';
import { InactivityCounterComponent } from './inactivity-counter/inactivity-counter.component';
import { IncidentsItemComponent } from './incidents-item/incidents-item.component';
import { InformationDoctorComponent } from './information-doctor/information-doctor.component';
import { InputSelectComponent } from './input-select/input-select.component';
import { InvoiceContentComponent } from './invoice-content/invoice-content.component';
import { InvoicesInValidationComponent } from './invoices-in-validation/invoices-in-validation.component';
import { InvoicesProcessComponent } from './invoices-process/invoices-process.component';
import { InvoicesTableInProcessComponent } from './invoices-table-in-process/invoices-table-in-process.component';
import { InvoicesTableComponent } from './invoices-table/invoices-table.component';
import { ListClasificationCatalogComponent } from './list-clasification-catalog/list-clasification-catalog.component';
import { ListMissingProductsComponent } from './list-missing-products/list-missing-products.component';
import { MatSpinnerComponent } from './mat-spinner/mat-spinner.component';
import { MissingProductItemComponent } from './missing-product-item/missing-product-item.component';
import { MonthsRangeSelectorComponent } from './months-range-selector/months-range-selector.component';
import { MyProfileAdviserTabComponent } from './my-profile-adviser-tab/my-profile-adviser-tab.component';
import { MyProfileTabComponent } from './my-profile-tab/my-profile-tab.component';
import { NoAvailableItemMessageComponent } from './no-available-item-message/no-available-item-message.component';
import { NotificationAvailableItemComponent } from './notification-available-item/notification-available-item.component';
import { OrderDescriptionComponent } from './order-description/order-description.component';
import { PaymentMethodsActionsComponent } from './payment-methods-actions/payment-methods-actions.component';
import { PaymentMethodsCardComponent } from './payment-methods-card/payment-methods-card.component';
import { PaymentMethodsImageComponent } from './payment-methods-image/payment-methods-image.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { PaypalButtonComponent } from './paypal-button/paypal-button.component';
import { PendingOrderTabComponent } from './pending-order-tab/pending-order-tab.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductDescriptionComponent } from './product-description/product-description.component';
import { ProductImageComponent } from './product-image/product-image.component';
import { ProductItemCatalogoComponent } from './product-item-catalogo/product-item-catalogo.component';
import { ProductTopListComponent } from './product-top-list/product-top-list.component';
import { ProgressBarGoalComponent } from './progress-bar-goal/progress-bar-goal.component';
import { PromotionalCodeFormComponent } from './promotional-code-form/promotional-code-form.component';
import { PromotionsCardComponent } from './promotions-card/promotions-card.component';
import { PromotionsImageComponent } from './promotions-image/promotions-image.component';
import { PromotionsListComponent } from './promotions-list/promotions-list.component';
import { QuotationChipsComponent } from './quotation-chips/quotation-chips.component';
import { QuotationFiltersComponent } from './quotation-filters/quotation-filters.component';
import { QuotationProductComponent } from './quotation-product/quotation-product.component';
import { RangeDateChooserComponent } from './range-date-chooser/range-date-chooser.component';
import { RecipeDermazoneComponent } from './recipe-dermazone/recipe-dermazone.component';
import { RecipeDirectionComponent } from './recipe-direction/recipe-direction.component';
import { RecipeComponent } from './recipe/recipe.component';
import { ResponsiveInvoiceItemComponent } from './responsive-invoice-item/responsive-invoice-item.component';
import { ResponsiveProductItemCatalogoComponent } from './responsive-product-item-catalogo/responsive-product-item-catalogo.component';
import { SalesProductComponent } from './sales-product/sales-product.component';
import { SapReportHeaderComponent } from './sap-report-header/sap-report-header.component';
import { SAPFilterTextComponent } from './sapfilter-text/sapfilter-text.component';
import { SaveShoppingCartButtonComponent } from './save-shopping-cart-button/save-shopping-cart-button.component';
import { ShoppingCarDetailComponent } from './shopping-car-detail/shopping-car-detail.component';
import { ShoppingCarTotalDetailComponent } from './shopping-car-total-detail/shopping-car-total-detail.component';
import { ShoppingCartButtonHeaderComponent } from './shopping-cart-button-header/shopping-cart-button-header.component';
import { ShoppingCartButtonComponent } from './shopping-cart-button/shopping-cart-button.component';
import { ShoppingCartListComponent } from './shopping-cart-list/shopping-cart-list.component';
import { TaxDataComponent } from './tax-data/tax-data.component';
import { TaxDirectionComponent } from './tax-direction/tax-direction.component';
import { TimeLineaDetailPackageComponent } from './time-linea-detail-package/time-linea-detail-package.component';
import { TimelineComponent } from './timeline/timeline.component';
import { TotalsDescriptionComponent } from './totals-description/totals-description.component';
import { UpdatePhotoComponent } from './update-photo/update-photo.component';
import { UtilitiesListComponent } from './utilities-list/utilities-list.component';
import { UtilityItemComponent } from './utility-item/utility-item.component';
import { YoutubePlayerComponent } from './youtube-player/youtube-player.component';
import { TableCommonComponent } from './table-common/table-common.component';
import { ChartCommonComponent } from './chart-common/chart-common.component';
import { CatalogSelectorComponent } from './catalog-selector/catalog-selector.component';
import { CatalogItemSelectionComponent } from './catalog-item-selection/catalog-item-selection.component';
import { ItemInputTextComponent } from './item-input-text/item-input-text.component';
import { GeneralSearchComponent } from './general-search/general-search.component';
import { GeneralSearchInputsComponent } from './general-search-inputs/general-search-inputs.component';
import { GeneralSearchChipsComponent } from './general-search-chips/general-search-chips.component';
import { SearchMobileComponent } from './search-mobile/search-mobile.component';
import { DisplayTimePaymentDialogButtonComponent } from './display-time-payment-dialog-button/display-time-payment-dialog-button.component';
import { PromotionBannerComponent } from './promotion-banner/promotion-banner.component';
import { ResponsibleDoctorsComponent } from './responsible-doctors/responsible-doctors.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { EmbeddedPowerBiComponent } from './embedded-power-bi/embedded-power-bi.component';
import { DynamicCarouselComponent } from './dynamic-carousel/dynamic-carousel.component';
import { RenderHtmlComponent } from './render-html/render-html.component';
import { CatalogSpecialtyViewComponent } from './catalog-specialty-view/catalog-specialty-view.component';
import { CatalogSublinesViewComponent } from './catalog-sublines-view/catalog-sublines-view.component';
import { MsiOptionsComponent } from './msi-options/msi-options.component';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 0,
    exitDuration: 0,
  },
};

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

function scrollFactory(overlay: Overlay): () => ScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

@NgModule({
  providers: [
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  declarations: [
    CounterPiecesComponent,
    TotalsDescriptionComponent,
    HeaderPageComponent,
    FavoriteComponent,
    ProductCardComponent,
    ShoppingCartButtonComponent,
    DetailOrdersListComponent,
    DeleteProductComponent,
    TaxDirectionComponent,
    CardOrderComponent,
    ContentEmptyComponent,
    FileSelectedComponent,
    IconPencilComponent,
    BreadcrumbsComponent,
    ChangeTaxDirectionComponent,
    DoctorInformationComponent,
    DeliveryAddressesComponent,
    AddDefaultAddressComponent,
    TaxDataComponent,
    PendingOrderTabComponent,
    BackOrderCardMobileComponent,
    ShoppingCartButtonHeaderComponent,
    MyProfileTabComponent,
    PaymentMethodsComponent,
    InformationDoctorComponent,
    PaymentMethodsCardComponent,
    PaymentMethodsActionsComponent,
    PaymentMethodsCardComponent,
    CodePayDescriptionComponent,
    UpdatePhotoComponent,
    ProductItemCatalogoComponent,
    MatSpinnerComponent,
    ResponsiveProductItemCatalogoComponent,
    InvoiceContentComponent,
    ResponsiveInvoiceItemComponent,
    RangeDateChooserComponent,
    MyProfileAdviserTabComponent,
    UtilityItemComponent,
    SalesProductComponent,
    ListClasificationCatalogComponent,
    ProductTopListComponent,
    FavoritesProductListComponent,
    HistoryOrdersListComponent,
    UtilitiesListComponent,
    ActiveOrderListComponent,
    ClientHeaderComponent,
    ChangePasswordComponent,
    MonthsRangeSelectorComponent,
    DeliveredOrdersListComponent,
    MissingProductItemComponent,
    ProductDescriptionComponent,
    ClientItemComponent,
    ProductImageComponent,
    InvoicesTableComponent,
    InputSelectComponent,
    CarouselComponent,
    CatalogDownloadComponent,
    HomeOptionImgComponent,
    FooterComponent,
    TimeLineaDetailPackageComponent,
    TimelineComponent,
    OrderDescriptionComponent,
    CatalogSpecialtyItemComponent,
    ContainerBioeliteComponent,
    ContainerBioEqualComponent,
    ContainerReveComponent,
    ContainerDermazoneComponent,
    AdvisorsDoctorComponent,
    IncidentsItemComponent,
    DownloadInvoiceComponent,
    ListMissingProductsComponent,
    InvoicesProcessComponent,
    InvoicesTableInProcessComponent,
    InvoicesInValidationComponent,
    AutocompleteCodeMissingComponent,
    AutocompleteMissingAutoComponent,
    AutocompleteMissingContainerComponent,
    BottomSheetMissingProductsComponent,
    GoBackAsesorComponent,
    BottomSheetDinamicComponent,
    GoalClientsComponent,
    ProgressBarGoalComponent,
    CircleLoadingComponent,
    AdvisorPromotionsComponent,
    PromotionsCardComponent,
    PromotionsImageComponent,
    PromotionsListComponent,
    PaymentMethodsImageComponent,
    EditAndRepurchaseComponent,
    CatalogsComponent,
    CatalogHeaderComponent,
    CatalogFiltersComponent,
    CatalogComboboxComponent,
    CatalogInputTextComponent,
    CatalogChipsComponent,
    CatalogItemsComponent,
    RecipeComponent,
    RecipeDermazoneComponent,
    GenerateOrderItemsComponent,
    DiscountMessageComponent,
    ShoppingCarDetailComponent,
    CustomPaginatorComponent,
    ShoppingCartListComponent,
    SaveShoppingCartButtonComponent,
    SapReportHeaderComponent,
    SAPFilterTextComponent,
    YoutubePlayerComponent,
    FaqTopicComponent,
    ConfirmShippingCostComponent,
    QuotationFiltersComponent,
    QuotationChipsComponent,
    QuotationProductComponent,
    NotificationAvailableItemComponent,
    NoAvailableItemMessageComponent,
    HoffmanMessageComponent,
    FaqsAccordionComponent,
    InactivityCounterComponent,
    DeliveryAddressListComponent,
    DirectionItemComponent,
    DeliveryDirectionsComponent,
    RecipeDirectionComponent,
    PaypalButtonComponent,
    ShoppingCarTotalDetailComponent,
    PromotionalCodeFormComponent,
    TableCommonComponent,
    ChartCommonComponent,
    CatalogSelectorComponent,
    CatalogItemSelectionComponent,
    ItemInputTextComponent,
    GeneralSearchComponent,
    GeneralSearchInputsComponent,
    GeneralSearchChipsComponent,
    SearchMobileComponent,
    DisplayTimePaymentDialogButtonComponent,
    PromotionBannerComponent,
    ResponsibleDoctorsComponent,
    EmbeddedPowerBiComponent,
    DynamicCarouselComponent,
    RenderHtmlComponent,
    CatalogSpecialtyViewComponent,
    CatalogSublinesViewComponent,
    MsiOptionsComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDialogModule,
    MatInputModule,
    PipesModule,
    MatTooltipModule,
    NgxMaskModule.forRoot(),
    InfiniteScrollModule,
    MatTableModule,
    MatRippleModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    NgxMonthPickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatCarouselModule.forRoot(),
    MatMenuModule,
    RouterModule,
    MatDividerModule,
    MatSlideToggleModule,
    NgCircleProgressModule,
    ClipboardModule,
    MatTabsModule,
    ScrollingModule,
    YouTubePlayerModule,
    MarkdownModule.forRoot(),
    NgxSpinnerModule,
    MatCardModule,
    AngularEditorModule,
    MatPaginatorModule
  ],
  exports: [
    CounterPiecesComponent,
    HeaderPageComponent,
    FavoriteComponent,
    ProductCardComponent,
    IconPencilComponent,
    ShoppingCartButtonComponent,
    TotalsDescriptionComponent,
    DetailOrdersListComponent,
    DeleteProductComponent,
    TaxDirectionComponent,
    CardOrderComponent,
    ContentEmptyComponent,
    FileSelectedComponent,
    ChangeTaxDirectionComponent,
    DoctorInformationComponent,
    BreadcrumbsComponent,
    DeliveryAddressesComponent,
    AddDefaultAddressComponent,
    TaxDataComponent,
    PendingOrderTabComponent,
    BackOrderCardMobileComponent,
    ShoppingCartButtonHeaderComponent,
    MyProfileTabComponent,
    PaymentMethodsComponent,
    InformationDoctorComponent,
    PaymentMethodsCardComponent,
    PaymentMethodsActionsComponent,
    CodePayDescriptionComponent,
    UpdatePhotoComponent,
    ProductItemCatalogoComponent,
    MatSpinnerComponent,
    ResponsiveProductItemCatalogoComponent,
    MyProfileAdviserTabComponent,
    InvoiceContentComponent,
    ResponsiveInvoiceItemComponent,
    UtilityItemComponent,
    RangeDateChooserComponent,
    MatProgressBarModule,
    SalesProductComponent,
    ListClasificationCatalogComponent,
    ProductTopListComponent,
    FavoritesProductListComponent,
    HistoryOrdersListComponent,
    UtilitiesListComponent,
    ActiveOrderListComponent,
    ClientHeaderComponent,
    ChangePasswordComponent,
    MonthsRangeSelectorComponent,
    DeliveredOrdersListComponent,
    MissingProductItemComponent,
    MatTooltipModule,
    ProductDescriptionComponent,
    ClientItemComponent,
    ProductImageComponent,
    InvoicesTableComponent,
    InputSelectComponent,
    CarouselComponent,
    CatalogDownloadComponent,
    HomeOptionImgComponent,
    FooterComponent,
    TimeLineaDetailPackageComponent,
    CatalogSpecialtyItemComponent,
    AdvisorsDoctorComponent,
    IncidentsItemComponent,
    ListMissingProductsComponent,
    InvoicesProcessComponent,
    InvoicesTableInProcessComponent,
    InvoicesInValidationComponent,
    AutocompleteCodeMissingComponent,
    AutocompleteMissingAutoComponent,
    AutocompleteMissingContainerComponent,
    GoBackAsesorComponent,
    BottomSheetDinamicComponent,
    GoalClientsComponent,
    ProgressBarGoalComponent,
    CircleLoadingComponent,
    AdvisorPromotionsComponent,
    PromotionsCardComponent,
    PromotionsImageComponent,
    PromotionsListComponent,
    PaymentMethodsImageComponent,
    EditAndRepurchaseComponent,
    CatalogsComponent,
    RecipeComponent,
    RecipeDermazoneComponent,
    GenerateOrderItemsComponent,
    DiscountMessageComponent,
    ShoppingCarDetailComponent,
    CustomPaginatorComponent,
    ShoppingCartListComponent,
    SapReportHeaderComponent,
    SAPFilterTextComponent,
    YoutubePlayerComponent,
    FaqTopicComponent,
    ConfirmShippingCostComponent,
    QuotationFiltersComponent,
    QuotationChipsComponent,
    QuotationProductComponent,
    NoAvailableItemMessageComponent,
    FaqsAccordionComponent,
    DeliveryDirectionsComponent,
    PaypalButtonComponent,
    ShoppingCarTotalDetailComponent,
    PromotionalCodeFormComponent,
    TableCommonComponent,
    ChartCommonComponent,
    CatalogSelectorComponent,
    GeneralSearchComponent,
    GeneralSearchInputsComponent,
    GeneralSearchChipsComponent,
    CatalogItemsComponent,
    SearchMobileComponent,
    DisplayTimePaymentDialogButtonComponent,
    PromotionBannerComponent,
    ResponsibleDoctorsComponent,
    EmbeddedPowerBiComponent,
    MsiOptionsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule { }
